import { client } from "./_base";

export interface ProductGroup {
  id?: number;
  group_code: string;
  group_description: string;
  created_at: Date;
  updated_at: Date;
}

const endpoint = "productgroup";

export const productgroup = client<ProductGroup>(endpoint, (item) => ({
  ...item,
}));
